module.exports =
  base: '/ecommerce/v2'
  workshop:
    base: '/ecommerce/v2/workshop'
    detail: '/ecommerce/v2/workshop/:eCommerceProductId'
  confirmation:
    base: '/ecommerce/v2/confirmation'
    detail: '/ecommerce/v2/confirmation/:eCommerceProductId'
  mockup:
    base: '/ecommerce/v2/mockup'
  submission: '/ecommerce/v2/submission/:jobId'
  data:
    eCommerceProduct:
      base: '/ecommerce/v2/data/eCommerceProduct'
      detail: '/ecommerce/v2/data/eCommerceProduct/:eCommerceProductId'
      endProduct: '/ecommerce/v2/data/eCommerceProduct/:eCommerceProductId/endProduct'
      submit: '/ecommerce/v2/data/eCommerceProduct/:eCommerceProductId/submit'
    queueJob: '/ecommerce/v2/data/queueJob/:jobId'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/ecommerce2.coffee